
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy, DatePipe, HashLocationStrategy } from '@angular/common';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FullComponent } from './layouts/full/full.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';

import { SharedModule } from './core/shared/shared.module';
import { SpinnerComponent } from './core/shared/spinner.component';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { AuthInterceptor } from './core/util/auth-interceptor';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PaginatorI18n } from './core/models/paginator/PaginatorI18n';
import { JwtModule } from '@auth0/angular-jwt';
import { API_DOMAIN } from './core/configurations/server-config';
import { AuthGuard } from './core/shared/guard/auth.guard';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { BnNgIdleService } from 'bn-ng-idle';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
// import * as $ from 'jquery';
import { ToastrModule } from 'ngx-toastr';
import { UserIdleModule } from 'angular-user-idle';
import { TimeoutComponent } from './module/timeout/timeout.component';
import { NgHttpLoaderModule } from 'ng-http-loader';
import {EcoFabSpeedDialModule} from '@ecodev/fab-speed-dial';
import { MatFabMenuModule } from '@angular-material-extensions/fab-menu';
import { PartitionmodalComponent } from './module/bordereau/partitionmodal/partitionmodal.component';
import { RoleGuard } from './core/shared/guard/role-guard';
import { FreepassengerTicketComponent } from './module/freepassengerTicket/freepassenger-ticket/freepassenger-ticket.component';
import { PreventDoubleSubmitModule } from 'ngx-prevent-double-submission';
import { SessionGuard } from './core/shared/guard/session-guard';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

export const createTranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
};

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    AppHeaderComponent,
    SpinnerComponent,
    AppSidebarComponent,
    TimeoutComponent,
    PartitionmodalComponent,
    FreepassengerTicketComponent,
  ],
  imports: [
    BrowserModule,
    NgHttpLoaderModule.forRoot(),
    BrowserAnimationsModule,
    DemoMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    HttpClientModule,
    SharedModule,
    MatMomentDateModule,
    MatFabMenuModule,
    EcoFabSpeedDialModule,
    UserIdleModule.forRoot({idle: 1800, timeout: 120, ping: 120}),
    ToastrModule.forRoot(),
    SweetAlert2Module.forRoot(),
    PreventDoubleSubmitModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [`${API_DOMAIN}`],
        disallowedRoutes: [`${API_DOMAIN}:8888/login`],
      },
    }),
    RouterModule.forRoot(AppRoutes),
    NgxMatSelectSearchModule
  ],
  providers: [
    {
      provide: LocationStrategy,
      // useClass: PathLocationStrategy
      useClass: HashLocationStrategy
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) =>
        new PaginatorI18n(translateService).getPaginatorIntl(),
    },
    AuthGuard,
    RoleGuard,
    SessionGuard,
    Title,
    DatePipe,
    BnNgIdleService,
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2000 } },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http);
}
export function tokenGetter(): any {
  return localStorage.getItem('access_token');
}
